const menuButtons = document.querySelectorAll('.mega-menu-button'); // these have dropdowns
const allMenuButton = document.querySelectorAll('.menu-button');
const menus = document.querySelectorAll('.mega-menu');

let ignoreClose = false;
let activeMenu = null;
let activeButton = null;


document.querySelectorAll('.announcement-bar-section')[0].addEventListener('mouseenter', () => {
  if(activeMenu) {
    closeMenu(activeMenu, activeButton);
  }
});

allMenuButton.forEach((button, index) => {
  button.addEventListener('mouseenter', () => {
    if(activeMenu) {
      closeMenu(activeMenu, activeButton);
    }
  });
});

menuButtons.forEach((button, index) => {

  button.addEventListener('mouseenter', (event) => {
    openMenu(menus[index], button);
  });

  button.addEventListener('click', (event) => {

    if(menus[index].classList.contains('show-menu')) {
      // Let the user navigate to the top level menu item URL
      // closeMenu(menus[index], button);
      if(ignoreClose) {
        event.stopPropagation();
        event.preventDefault();
      }
    } else {
      event.stopPropagation();
      event.preventDefault();
      openMenu(menus[index], button);
    }
  });
});

menus.forEach((menu, index) => {
  menu.addEventListener('mouseleave', () => {
    closeMenu(menu, menuButtons[index]);
  });
});

document.addEventListener('click', (event) => {
  if (!event.target.closest('.mega-menu') && !event.target.closest('.header') && !event.target.closest('.mega-menu-button')) {
    menus.forEach((menu, index) => {
      closeMenu(menu, menuButtons[index]);
    });
  }
});


function closeMenu(menu, button) {
  if(ignoreClose) {
    return;
  }
  activeMenu = null;
  activeButton = null;
  if (menu.classList.contains('show-menu')) {
    menu.classList.remove('show-menu');
    document.querySelector('.header').classList.remove('mega-menu-active');
    document.body.classList.remove('body-lock', 'primary-nav-open');
    button.classList.remove('active-button');
  }
}


function openMenu(menu, button) {
  if(!button.classList.contains('mega-menu-button')) {
    return; // it does not have a dropdown menu
  }

  ignoreClose = true;
  setTimeout(() => {
    ignoreClose = false;
  }, 50);

  activeMenu = menu;
  activeButton = button;
  menu.classList.add('show-menu');
  document.querySelector('.header').classList.add('mega-menu-active');
  document.body.classList.add('body-lock', 'primary-nav-open');
  button.classList.add('active-button');
}